module.exports = __webpack_public_path__ + "static/travel-berlin-787116d906404d30c8237d1580a308e3.jpg";